export default function offerParamsOptionsResolver({ offer, offerSettings, on }) {
    return {
        bind: {
            offer,
            offerSettings,
        },
        on: {
            'change-offer': on.changeOffer,
            'load-grouped-offers': on.loadGroupedOffers,
        },
    };
}
